import React, { useState } from "react";
import { Button, CardBody, Form, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import { Container, Title, Wrapper } from "./ChangePassword.styled";

/**
 * @typedef {Object} Props
 * @prop {import("./types").ChangePasswordFn} onSubmit
 */

/**
 * Change password UI
 * @param {Props} props 
 * @return {React.JSXElementConstructor<Props>}
 */
const ChangePassword = props => {
  const { onSubmit } = props


  const [password, setPassword] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  })
  const [error, setError] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  })

  /** @type {import("reactstrap").InputProps['onChange']} */
  const _onInputChange = (e) => {
    const { name, value } = e.target
    setPassword({ ...password, [name]: value })
  }

  /** @type {(value: string, fieldName: string) => string} */
  const _checkPasswordGeneralRules = (value, fieldName) => {
    if (!value) {
      return `Please input your ${fieldName.toLowerCase()}`
    } else if (value.length < 8) {
      return `${fieldName} must be at least 8 characters`
    } else if (value.length > 16) {
      return `${fieldName} can be at most 16 characters`
    }
  }

  /** @type {import("reactstrap").ButtonProps['onSubmit']} */
  const _onSubmit = async (e) => {
    e.preventDefault()
    console.log(password)

    const { oldPassword, newPassword, confirmPassword } = password
    /** @type {typeof error} */
    const newError = {
      oldPassword: _checkPasswordGeneralRules(oldPassword, "Old password"),
      newPassword: _checkPasswordGeneralRules(newPassword, "New password"),
      confirmPassword: _checkPasswordGeneralRules(confirmPassword, "Confirm password"),
    }

    if (newPassword !== confirmPassword) {
      newError.confirmPassword = 'Confirm password not match'
    }

    setError(newError)
    if (newError.oldPassword || newError.newPassword || newError.confirmPassword) {
      return
    }

    const success = await onSubmit(oldPassword, newPassword)
    if (success) {
      // Clear form
      setPassword({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      })
    }
  }

  return (
    <Container>
      <Wrapper>
        <Title>Change Password</Title>
        <CardBody>
          <Form>
            <FormGroup floating>
              <Input
                type="password"
                name="oldPassword"
                placeholder="Old password"
                invalid={!!error.oldPassword}
                value={password.oldPassword}
                onChange={_onInputChange}
              />
              <Label for="oldPassword">Old password</Label>
              <FormFeedback>{error.oldPassword}</FormFeedback>
            </FormGroup>
            <FormGroup floating>
              <Input
                type="password"
                name="newPassword"
                placeholder="New password"
                invalid={!!error.newPassword}
                value={password.newPassword}
                onChange={_onInputChange}
              />
              <Label for="newPassword">New password</Label>
              <FormFeedback>{error.newPassword}</FormFeedback>
            </FormGroup>
            <FormGroup floating>
              <Input
                type="password"
                name="confirmPassword"
                placeholder="Confirm password"
                invalid={!!error.confirmPassword}
                value={password.confirmPassword}
                onChange={_onInputChange}
              />
              <Label for="confirmPassword">Confirm password</Label>
              <FormFeedback>{error.confirmPassword}</FormFeedback>
            </FormGroup>
            <FormGroup className="text-center">
              <Button color="primary" onClick={_onSubmit}>Submit</Button>
            </FormGroup>
          </Form>
        </CardBody>
      </Wrapper>
    </Container>
  )
}

export default ChangePassword